import { useState } from "react";
import { API, getToken } from "@/lib/api";
import { FileDown } from "lucide-react";

const label = (m) => new Date(`${m}-01T00:00:00`).toLocaleDateString("en-IN", { month: "short", year: "numeric" });

export const monthsOf = (rows) => {
    const now = new Date().toISOString().slice(0, 7);
    return [...new Set([now, ...(rows || []).map((p) => (p.created_at || "").slice(0, 7)).filter(Boolean)])].sort().reverse();
};

// Month picker + download link for a professional's monthly payout statement PDF.
export function StatementDownload({ months, professionalId, testid = "statement", accent = "#09233B" }) {
    const [month, setMonth] = useState(months[0]);
    const q = new URLSearchParams({ month, auth: getToken() || "" });
    if (professionalId) q.set("professional_id", professionalId);
    return (
        <div className="flex items-center gap-2" data-testid={`${testid}-box`}>
            <select data-testid={`${testid}-month`} value={month} onChange={(e) => setMonth(e.target.value)} className="rounded-full border border-navy/15 bg-white px-3 py-1.5 text-xs font-semibold text-navy outline-none">
                {months.map((m) => <option key={m} value={m}>{label(m)}</option>)}
            </select>
            <a data-testid={`${testid}-download`} href={`${API}/payouts/statement.pdf?${q.toString()}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 rounded-full px-3 py-1.5 text-xs font-bold text-white" style={{ backgroundColor: accent }}>
                <FileDown size={13} /> Statement
            </a>
        </div>
    );
}
